import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSection = styled.section`
  position: relative;
  overflow: hidden;
  padding: calc(var(--nav-height) + 84px) 0 56px;
  background: var(--paper);
  background-image: radial-gradient(800px 420px at 88% -10%, rgba(86, 112, 246, 0.14), transparent 62%),
    radial-gradient(600px 360px at 0% 110%, rgba(253, 118, 255, 0.1), transparent 60%);
  border-bottom: 1px solid var(--line);

  @media (max-width: 768px) {
    padding: calc(var(--nav-height) + 56px) 0 40px;
  }
`;

const StyledInner = styled.div`
  ${({ theme }) => theme.mixins.container};
  max-width: 820px;
`;

const StyledTitle = styled.h1`
  margin: 0 0 18px;
`;

const StyledLead = styled.p`
  max-width: 680px;
  margin: 0;
  color: var(--text-soft);
  font-size: var(--fz-lg);
`;

const PageHero = ({ eyebrow, title, lead, children }) => (
  <StyledSection>
    <StyledInner>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <StyledTitle>{title}</StyledTitle>
      {lead && <StyledLead>{lead}</StyledLead>}
      {children}
    </StyledInner>
  </StyledSection>
);

PageHero.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string.isRequired,
  lead: PropTypes.string,
  children: PropTypes.node,
};

PageHero.defaultProps = {
  eyebrow: null,
  lead: null,
  children: null,
};

export default PageHero;
